import { getTranslationFromJson } from '@patrianna/shared-utils/prismic'
import { Facebook } from '@patrianna-icons/material-icons'

import content from 'prismic-translates/page-profile.json'
import Button from 'src/components/Button'

import classes from './styles.module.scss'

type Props = {
  connected: boolean
  handleClick: () => void
}

const t = getTranslationFromJson([content])

function FacebookConnected(props: Props) {
  if (!props.connected) {
    return (
      <Button className={classes.fbBtn} onClick={props.handleClick}>
        <Facebook className={classes.fbIcon} />
        {t('connect_with_fb')}
      </Button>
    )
  }

  return <>{t('fb_connected')}</>
}

export default FacebookConnected
